// extracted by mini-css-extract-plugin
export default {"pagination":"_1yP2M","list":"_1zHJX","page":"_2unUu","disabled":"_1vQr2","link":"_3ZJ4-","first":"_2zAxN","prev":"_2eQlC","last":"_2bSw8"};